import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import { Home } from 'screens/Home'
import { Dailymotion } from 'screens/Dailymotion'
import { LandingPage } from 'screens/LandingPage'
import { Predict6 } from 'screens/Predict6'
import { TntScreen } from 'screens/tntScreen'
import { YesNoResults, YesNo } from 'screens/YesNo'
import euroleagueLogo from 'assets/euroleague.png'
import tv2Logo from 'assets/tv2Logo.png'
import tv2Bg from 'assets/tv2Bg.jpg'
import ligamx from 'assets/ligamx.png'
import sfxBg from 'assets/SFX_Background.jpg'
import yesNo from 'assets/yesno.png'
import motogp from 'assets/motogp.png'
import fifa2 from 'assets/fifa2.png'
import ch5Logo from 'assets/ch5-sponsor.png'
import ch5TennisLogo from 'assets/ch5-tennis-logo.png'
import premierLeagueLogo from 'assets/premier-league-logo.png'
import cyafLogo from 'assets/cyaf-logo.png'
import mlsLogo from 'assets/mls-logo.png'
import { Jwplayer } from 'screens/Jwplayer'
import { Sports360 } from 'screens/Sports360'
import { CwcScreen } from 'screens/cwcScreen'
import { WeuroScreen } from 'screens/weuroScreen'
import { Ch5Screen } from 'screens/ch5Screen'
import { Ch5TennisScreen } from 'screens/ch5TennisScreen'
import { PremierLeagueScreen } from 'screens/premierLeagueScreen'
import { MlsScreen } from 'screens/mlsScreen'
import { CyafScreen } from 'screens/cyaf'

const Routes = () => (
  <Router>
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      <Route exact path="/euroleague">
        <LandingPage logo={euroleagueLogo} isPreStream />
      </Route>
      <Route exact path="/tv2">
        <LandingPage
          client="tv-2"
          logo={tv2Logo}
          bgImage={tv2Bg}
          isPreStream={false}
        />
      </Route>
      <Route exact path="/yesNo">
        <YesNo client="sportbuff" logo={yesNo} anonymousLogin />
      </Route>
      <Route exact path="/YesNoResults">
        <YesNoResults />
      </Route>
      <Route exact path="/sfx">
        <LandingPage client="sportbuff" bgImage={sfxBg} isPreStream />
      </Route>
      <Route exact path="/predict6">
        <Predict6 logo={ligamx} />
      </Route>
      <Route exact path="/televisa">
        <Predict6 logo={ligamx} />
      </Route>
      <Route exact path="/tnt">
        <TntScreen logo={motogp} routeName="tnt" />
      </Route>
      <Route exact path="/cwc">
        <CwcScreen logo={fifa2} routeName="cwc" />
      </Route>
      <Route exact path="/weuro">
        <WeuroScreen logo={fifa2} routeName="weuro" />
      </Route>
      <Route exact path="/ch5">
        <Ch5Screen logo={ch5Logo} routeName="ch5" />
      </Route>
      <Route exact path="/ch5Tennis">
        <Ch5TennisScreen logo={ch5TennisLogo} routeName="ch5Tennis" />
      </Route>
      <Route exact path="/prem">
        <PremierLeagueScreen logo={premierLeagueLogo} routeName="prem" />
      </Route>
      <Route exact path="/mls">
        <MlsScreen logo={mlsLogo} routeName="mls" />
      </Route>
      <Route exact path="/cyaf">
        <CyafScreen logo={cyafLogo} routeName="cyaf" />
      </Route>
      <Route exact path="/pregame">
        <LandingPage isPreStream />
      </Route>
      <Route exact path="/playlist">
        <Home isPlaylistMode />
      </Route>
      <Route exact path="/tv">
        <Home isTvMode />
      </Route>
      <Route exact path="/portrait">
        <Home fixedPortraitBuffs />
      </Route>
      <Route exact path="/tvsync">
        <Home isTvMode isTimeSync />
      </Route>
      <Route exact path="/dailymotion">
        <Dailymotion />
      </Route>
      <Route exact path="/jwplayer">
        <Jwplayer />
      </Route>
      <Route exact path="/360sports">
        <Sports360 />
      </Route>
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  </Router>
)

export default Routes
